import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableRow } from '@material-ui/core';
import React, { useState } from 'react';
import { CheckListNotes } from './CheckListNotes';
import { usePendingCheckList } from '../../projectManagementQueries';


export const PendingDialogComponent = ({ id, is_writer }: any) => {
    const [open, setOpen] = useState(false);

    const {
        data: availableCheckListdata,
        isLoading: isLoadingAvailableCheckList,
        isError: isAvailableCheckListError,
        error: availableCheckListError,
        refetch: refetchAvailableCheckList,
    } = usePendingCheckList(id);



    

    const handleOpenDialog = () => {
        setOpen(true);
    };

    const handleCloseDialog = () => {
        setOpen(false);
    };

    if(isLoadingAvailableCheckList){
        return <CircularProgress />
    }

    return (
        <>{is_writer && (
            <Box display="flex" justifyContent="flex-end" mt={1}>
                <Button
                    variant="contained"
                    style={{ backgroundColor: "red" }}
                    onClick={handleOpenDialog}
                >
                    Pending CheckList
                </Button>
            </Box>
        )
        }

            <Dialog open={open} onClose={handleCloseDialog} maxWidth="lg" fullWidth>
                <DialogTitle>Pending CheckList Status</DialogTitle>
                <DialogContent>
                    <TableContainer
                        component={Paper}
                        style={{
                            marginTop: 16,
                            border: "2px solid #B0B0B0",
                            borderRadius: 8,
                            padding: 18,
                        }}
                    >
                        <Table size="small">
                            <TableBody>
                                {availableCheckListdata?.[0].check_list?.map((checkList: any) => (
                                    <React.Fragment key={checkList.category}>

                                        <TableRow style={{ backgroundColor: "#FFC107", height: 30 }}>
                                            <TableCell
                                                colSpan={3}
                                                align="center"
                                                style={{ fontWeight: "bold" }}
                                            >
                                                {checkList.category}
                                            </TableCell>
                                        </TableRow>


                                        {checkList.check_point?.map((item: any) => (
                                            <TableRow key={item.id} style={{ height: 30 }}>
                                                <TableCell padding="none" style={{ marginLeft: 20 }}>{item.description}</TableCell>

                                                {/* <TableCell align="center" padding="none">
                                                    <Checkbox
                                                        checked={
                                                            UpdateStatusData.find((s: any) => s.id === item.id)?.status ??
                                                            item.status
                                                        }
                                                        onChange={(e) => handleUpdateStatusChange(item.id, e.target.checked)}
                                                        icon={<RadioButtonUncheckedIcon />}
                                                        checkedIcon={<CheckCircleIcon />}
                                                        color="primary"
                                                    />
                                                </TableCell> */}

                                                <TableCell align="center" padding="none">
                                                    <IconButton>
                                                        <CheckListNotes
                                                            id={id}
                                                            check_list_report_id={availableCheckListdata?.[0]?.category_id}
                                                            check_list_id={item.id}
                                                            count={item.note_count}
                                                            Writer={true}
                                                        />
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </React.Fragment>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}


